import { HttpClient } from '@angular/common/http';
import { Injector } from "@angular/core";
import { Observable } from 'rxjs/internal/Observable';

export abstract class ProviderBase {
    private http: HttpClient
    constructor(injector: Injector, private path: string) {
        this.http = injector.get(HttpClient);
    }

    protected get<T>(endpoint: string): Observable<T> {
        return this.http.get<T>(this.path + endpoint);
    }
}